import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import InvoiceGenerator from "./components/InvoiceGenerator";
import "./index.css";

function App() {
  const session = JSON.parse(localStorage.getItem("auth"));

  const isAuth =
    session && new Date().getTime() < session.expiry;

  return (
    <Routes>
      {/* Login Route */}
      <Route
        path="/"
        element={
          isAuth ? (
            <Navigate to="/invoice" replace />
          ) : (
            <Login />
          )
        }
      />

      {/* Protected Invoice Route */}
      <Route
        path="/invoice"
        element={
          isAuth ? (
            <InvoiceGenerator />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      {/* Any random URL */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;